__turbopack_context__.v({
  "image-crop": "ImageEditor-module-scss-module__-fimKW__image-crop",
  "image-crop-fade-in": "ImageEditor-module-scss-module__-fimKW__image-crop-fade-in",
  "image-editor-buttons": "ImageEditor-module-scss-module__-fimKW__image-editor-buttons",
  "image-editor-frame": "ImageEditor-module-scss-module__-fimKW__image-editor-frame",
});
